import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { LeadFormComponent } from 'src/app/modules/lead-managment/add/lead-form.component';
import { RECORD_STATUS_VALUES, TRAVEL_SERVICES } from 'src/app/modules/shared/constants/api-constants';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { LovDataService } from 'src/app/modules/shared/services/lov-data/lov-data.service';
import { ComponentReloadService } from 'src/app/modules/shared/services/reload/component-reload.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { InputValidationsService } from 'src/app/modules/shared/services/validations/input-validations.service';

@Component({
  selector: 'app-lead-information',
  templateUrl: './lead-information.component.html',
  styleUrls: ['./lead-information.component.scss'],
})
export class LeadInformationComponent  implements OnInit {

  @Input() leadId:any;
  @Input() cloneItineraryId:any;
  @Input() clientId:any;
  @Input() leadDetails:any;
  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() updateLeadServices: EventEmitter<any> = new EventEmitter<any>();

  @Output() tourPackageRemoved: EventEmitter<void> = new EventEmitter<void>();
  impactTourPackageChange:boolean = false;

  @Output() newLeadCreated: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(LeadFormComponent) leadFormComponent!:LeadFormComponent;

  leadServicesForm!: FormGroup;
  disableServiceType: boolean = false;
  
  travelServices:any;

  showLeadForm: boolean = false;

  constructor(
    private _fb: FormBuilder,
    private _leadService: LeadsService,
    private _lovDataService: LovDataService,
    private _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService,
    private _validationService: InputValidationsService,
    private _reloadService: ComponentReloadService
  ) { }

  ngOnInit() {
    if(this.leadDetails){  
      this.leadServicesForm = this._fb.group({
        travelServices: [[], [this._validationService.arrayNotEmptyValidator()]],
        leadNote: [""]
      });
  
      this.leadServicesForm.valueChanges.subscribe(()=>{
        this.leadServicesForm.markAsTouched();
      })
  
      this._lovDataService.getLovData("TravelServices").subscribe((data)=>{
        this.travelServices = data.map((item: { name: any; })=> item.name);
      })
      this.patchLeadServicesValues(this.leadDetails);
    } else if (this.cloneItineraryId){
      this.showLeadForm = true;
    }
  }

  patchLeadServicesValues(formData:any){
    this.leadServicesForm.patchValue({
      travelServices: formData.travelServices
    });

    if(formData.status === RECORD_STATUS_VALUES.QUOTE_CREATED || formData.status === RECORD_STATUS_VALUES.CONVERTED || formData.status === RECORD_STATUS_VALUES.TRIP_COMPLETED){
      this.disableServiceType = true;
    }
  }

  clearServices(){
    this.leadServicesForm.get("travelServices")?.setValue([]);
  }

  leadCreated(leadId:any){
    this.newLeadCreated.emit(leadId);
  }

  async onSubmit(): Promise<boolean> {
    if(this.leadDetails){
      if (!this.leadServicesForm.valid) {
        this.leadServicesForm.markAllAsTouched();
        this._globalService.scrollToFirstInvalidControl();
        this._globalService.customAlert("Form not valid, select at least one service!");
        return false; // Form is invalid
      }
    
      try {
        const formData = await this.serializeEditFormData(this.leadServicesForm.value);
    
        const data = await this._leadService.updateLead(this.leadId, formData).toPromise();
    
        if(this.impactTourPackageChange){
          this.tourPackageRemoved.emit();
        }
        this._responseNotificationService.showMessage("Updated lead's services!");
        this._reloadService.triggerLeadsReload();
        this.updateLeadServices.emit();
        this.leadServicesForm.markAsPristine();
    
        return true; // Form submitted successfully
      } catch (error) {
        console.error("Error updating lead services:", error);
        return false; // Submission failed
      }
    }else{
      if(await this.leadFormComponent.onSubmit(false, false, true)){
        return true;
      }else{ 
        return false; 
      }
    }
    
  }
  

  private async serializeEditFormData(formData: any) {
    var serializedData = this.leadDetails;
    let tempNote = {
      note: formData.leadNote,
      userId: localStorage.getItem("jti"),
      createDate: this._globalService.getTodaysDateTime()
    }
    if(formData.leadNote && serializedData.leadNotes){
      serializedData.leadNotes.push(tempNote);
    }

    if((serializedData.travelServices?.includes(TRAVEL_SERVICES.SIGHTSEEING) && !formData.travelServices?.includes(TRAVEL_SERVICES.SIGHTSEEING)) ||
       (!serializedData.travelServices?.includes(TRAVEL_SERVICES.SIGHTSEEING) && formData.travelServices?.includes(TRAVEL_SERVICES.SIGHTSEEING))){
      this.impactTourPackageChange = true;
    }

    serializedData.travelServices = formData.travelServices;

    
    
    return serializedData;
  }

  async resetForm(){
    if(await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")){
      this.ngOnInit();
    }    
  }

  goPrevious(){
    this.viewChange.emit(true);
  }

  goNext(){
    this.viewChange.emit(false);
  }

  async saveAndNext(){
    if(await this.onSubmit()){
      this.goNext()
    }
  }

  formDataModified(): boolean {
    if(this.leadDetails){
      return (this.leadServicesForm?.dirty || this.leadServicesForm?.invalid) && this.leadServicesForm?.touched;
    }else{
      return true;
    }
    
  }

}
